
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/AboutCompany",
      function () {
        return require("private-next-pages/AboutCompany/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/AboutCompany"])
      });
    }
  